import { Component } from "@angular/core";


@Component({
  standalone: false,
    selector: 'wfm-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})

export class ErrorComponent {
   

}